import { StatusLabelWrapper } from './styled.js'
import { FaGenderless } from "react-icons/fa";

function StatusLabel({ status = 0 }) {
    return (
        <StatusLabelWrapper>
            <div className="status_label">
                {
                    status === 0 &&
                    <span className='status_label_wait no-wrap-content'>
                        <i><FaGenderless /></i> Chờ xác nhận
                    </span>
                }
                {
                    status === 1 &&
                    <span className='status_label_delivering no-wrap-content'>
                        <i><FaGenderless /></i> Đang thực hiện
                    </span>
                }
                {
                    status === 2 &&
                    <span className='status_label_delivered no-wrap-content'>
                        <i><FaGenderless /></i> Hoàn thành
                    </span>
                }
                {
                    status === 3 &&
                    <span className='status_label_cancelled no-wrap-content'>
                        <i><FaGenderless /></i> Đã hủy
                    </span>
                }
            </div>
        </StatusLabelWrapper>
    );
}

export default StatusLabel
